<template lang='pug'>
    div
        PDaccessoriesSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")
            section.title-container
                h1.product-title CAL-UHF Accessory Kit
                h2.product-subtitle Robust accessory case with cables and connectors for the CAL-UHF calibrator

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.webp')
                            img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.png', width='70%', alt='Open CAL-UHF accessory kit with calibrator and accessories', title='CAL-UHF Accessory Kit')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Complete accessory kit for quick and reliable CAL-UHF connection
                                li Includes cables and adapters for flexible on-site use
                                li Includes various lengths of coaxial cable
                                li Clearly organized case for fast access and safe transport
                                li Compatible with standard N interfaces
                                li Suitable for laboratory and field measurement applications
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link='/pdf/Datasheet CAL-UHF Accessory Kit.pdf')
                            Maillink(to='support@bss-hs.de', sub='CAL-UHF Accessory Kit', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to='/en/products/cal-uhf', text='CAL-UHF UHF PD Calibrator')

            section.margin-bottom
                .column-container
                    .column
                        p The accessory kit complements the CAL-UHF calibrator to form a ready-to-use solution for laboratory and field applications. The carefully selected connection cables and adapters enable flexible connection possibilities to cover all conditions encountered during field operation.
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var2.webp')
                            img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var2.jpg', width='100%', alt='CAL-UHF accessory kit cables and adapters', title='CAL-UHF Accessory Kit Cables and Adapters')

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_white_shadow_Var3.webp')
                            img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_white_shadow_Var3.png', width='80%', alt='Closed CAL-UHF accessory kit case', title='CAL-UHF Accessory Kit Case')
                    .column
                        p The robust carrying case provides ample space for the CAL-UHF calibrator and all accessories, while reliably protecting the components during transport. Its clearly structured interior layout allows quick identification and easy access to the required parts.

        div.fullwidth(v-if="$route.params.lang == 'de'")
            section.title-container
                h1.product-title CAL-UHF Zubehörset
                h2.product-subtitle Robuster Zubehörkoffer mit Kabeln und Anschlüssen für den CAL-UHF Kalibrator

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.webp')
                            img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.png', width='70%', alt='Geöffnetes CAL-UHF Zubehörset mit Kalibrator und Zubehör', title='CAL-UHF Zubehörset')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Komplettes Zubehörset für den schnellen und zuverlässigen Anschluss des CAL-UHF
                                li Kabel und Adapter für den flexiblen Einsatz vor Ort
                                li Koaxialkabel in verschiedenen Längen
                                li Übersichtlich angeordneter Koffer für schnellen Zugriff und sicheren Transport
                                li Kompatibel mit gängigen N-Anschlüssen
                                li Für Messungen im Labor und im Feldeinsatz geeignet

                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link='/pdf/Datasheet CAL-UHF Accessory Kit.pdf')
                            Maillink(to='support@bss-hs.de', sub='CAL-UHF Zubehörset', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to='/de/products/cal-uhf', text='CAL-UHF TE-Kalibrator')

            section.margin-bottom
                .column-container
                    .column
                        p Das Zubehörset ergänzt den CAL-UHF Kalibrator zu einer sofort einsatzbereiten Lösung für Labor- und Feldeinsätze. Die praxisgerecht ausgewählten Anschlusskabel und Adapter ermöglichen flexible Anschlussmöglichkeiten für alle im Feldeinsatz auftretenden Bedingungen.
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var2.webp')
                            img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var2.jpg', width='100%', alt='Kabel und Adapter des CAL-UHF Zubehörsets', title='Kabel und Adapter des CAL-UHF Zubehörsets')

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_white_shadow_Var3.webp')
                            img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_white_shadow_Var3.png', width='80%', alt='Geschlossener Koffer des CAL-UHF Zubehörsets', title='Koffer des CAL-UHF Zubehörsets')
                    .column
                        p Der robuste Transportkoffer bietet ausreichend Platz für den CAL-UHF Kalibrator und sämtliches Zubehör und schützt die Komponenten zuverlässig während des Transports. Die klar strukturierte Innenaufteilung ermöglicht eine schnelle Identifikation und einen einfachen Zugriff auf die benötigten Teile.
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | CAL-UHF Zubehörset",
            description: "Zubehörkoffer mit Kabeln und Adaptern für den CAL-UHF Kalibrator",
        },
        en: {
            title: "BSS | CAL-UHF Accessory Kit",
            description: "Accessory case with cables and adapters for the CAL-UHF calibrator",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>